import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.css']
})
export class PageTitleComponent implements OnInit {

  userData:any = [];
  userName = null;
  currentRoute = null;
  userLevel = null;
  titleName= null;
  profileData = null;
  constructor(private router: Router) { }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('userData'));
    console.log("this.userData ", this.userData )
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
      this.titleName = this.userData['user_profile_id'];
      // this.profileData = JSON.parse(localStorage.getItem('profileData'));
      this.profileData = localStorage.getItem('profileData') && (localStorage.getItem('profileData') !='undefined') ? JSON.parse(localStorage.getItem('profileData')) : null;

      if(this.userLevel == 'industry'){
        // this.titleName = this.profileData.employee_first_name + " " + this.profileData.employee_last_name
        this.titleName = this.userName
      }
      if(this.userLevel == 'admin' && this.profileData){
        this.titleName = this.profileData.employee_first_name + " " + (this.profileData.employee_last_name ? this.profileData.employee_last_name : '')
      }
      if(this.userLevel == 'vendor'){
        this.titleName = this.userData['vendor_name'] ? this.userData['vendor_name']: this.userName;
      }

    }

    this.currentRoute = this.router.url.replace('/', '');
  }

}
